































import BaseFormMixin from '@/mixins/base-form-mixin';
import { DatasourceDto } from '@/services/datasource';
import { mixins } from 'vue-class-component';
import { Component, PropSync } from 'vue-property-decorator';

@Component
export default class esConfForm extends mixins(BaseFormMixin) {
  @PropSync('formData') syncFormData!: DatasourceDto;

  mounted() {
    this.syncFormData.esConf = {
      hostsInput: '',
      hosts: [],
      clusterName: '',
      username: '',
      password: '',
      type: '',
      index: ''
    };
  }
}
